import { t } from "i18next";

import type { ColumnsClarFactory } from "@/core/components/shared/data-table";
import { NoTranslate } from "@/core/components/ui/no-translate";
import { formatMinorAmount } from "@/core/utils/func/money-minor";
import type { SubscriptionPlanDto } from "@/features/fee-engine/api/dto";

export type SubscriptionPlanRow = SubscriptionPlanDto & { id: string };

/** Colonnes de la liste des plans d'abonnement (`POST /SubscriptionPlans/all`). */
export const subscriptionPlansColumns: ColumnsClarFactory<SubscriptionPlanRow> = () => [
  {
    id: "code",
    accessorKey: "code",
    header: t("fees.plans.columns.code"),
    cell: ({ getValue }) => (
      <NoTranslate as="span" className="font-mono font-semibold">
        {(getValue() as string) || "—"}
      </NoTranslate>
    ),
    meta: { type: "text" },
  },
  {
    id: "name",
    accessorKey: "name",
    header: t("fees.plans.columns.name"),
    cell: ({ getValue }) => (
      <span className="font-medium">{(getValue() as string) || "—"}</span>
    ),
    meta: { type: "denied" },
  },
  {
    id: "minEmployees",
    accessorKey: "minEmployees",
    header: t("fees.plans.columns.minEmployees"),
    cell: ({ getValue }) => (
      <NoTranslate as="span">{String(getValue() ?? "—")}</NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "maxEmployees",
    accessorKey: "maxEmployees",
    header: t("fees.plans.columns.maxEmployees"),
    cell: ({ getValue }) => (
      <NoTranslate as="span">{String(getValue() ?? "—")}</NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "monthlyPrice",
    accessorKey: "monthlyPriceMinor",
    header: t("fees.plans.columns.monthlyPrice"),
    cell: ({ row }) => (
      <NoTranslate as="span" className="font-semibold">
        {formatMinorAmount(
          row.original.monthlyPriceMinor,
          row.original.currency
        )}
      </NoTranslate>
    ),
    meta: { type: "denied" },
  },
  {
    id: "currency",
    accessorKey: "currency",
    header: t("fees.plans.columns.currency"),
    cell: ({ getValue }) => (
      <NoTranslate as="span">{(getValue() as string) || "—"}</NoTranslate>
    ),
    meta: { type: "denied" },
  },
];
